<template>
  <div class="row">
    <div class="col-12">
      <table class="table" v-bind:class="{ keyFacts: props.blockData.key_fact }">
        <tbody>
        <tr v-for="(row, index) in props.blockData.rows">
          <td>{{ row.label }}</td>
          <td>{{ row.value }}</td>
        </tr>
        </tbody>
      </table>
      <div class="table-footer" v-html="props.blockData.footer"></div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  blockData: Object
})
</script>